import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import "./game.css";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

function Esports() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [profile, setProfile] = useState(null);
    const [playGame, setPlayGame] = useState(null);
    const [product, setProduct] = useState(null);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    function isMobileDevice() {
        if (window.innerWidth < 800) {
            return true;
        }
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    const cockfightProviders = [
        { 
            id: "ws168", 
            name: "WS168 Đá Gà",
            product_type: "202",
            game_code: "WS1682",
            img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/cockfight/cf361.png" 
        },
        { 
            id: "sv388", 
            name: "SV388 Đá Gà",
            product_type: "132",
            game_code: "SV3002",
            img: require("../../image/common/sv388.png") 
        }
    ];

    // ==========================================
    // LOGIC VÀO GAME & TỰ ĐỘNG CHUYỂN TIỀN VÀO
    // ==========================================
    const launchGame = async (params) => {
        if (localStorage.getItem("profile") == null || localStorage.getItem("profile") === "undefined") {
            navigate("/login");
            return;
        }
        if (isLoading) return;
        setLoading(true);

        try {
            // 1. Lấy link game
            const form = {
                ...params,
                platform: isMobileDevice() ? "html5" : "html5-desktop"
            };
            const resGame = await axios.post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form);
            
            if (resGame.data.data.status !== 0) {
                setLoading(false);
                swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                return;
            }

            const gameUrl = resGame.data.data.game_url;
            setProduct(params.product_type);

            // 2. Tự động chuyển toàn bộ tiền từ ví chính vào sảnh
            if (profile && profile.money >= 1000) {
                try {
                    await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: params.product_type,
                        type: 1, // 1 là chuyển vào
                        money: Math.floor(profile.money)
                    });
                } catch (transferErr) {
                    console.log("Lỗi chuyển tiền vào sảnh, vẫn tiếp tục mở game:", transferErr);
                }
            }

            // 3. Mở game trực tiếp trên Web
            setPlayGame(gameUrl);
            setLoading(false);

        } catch (err) {
            setLoading(false);
            if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                return;
            }
            swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
        }
    };

    // ==========================================
    // LOGIC THOÁT GAME & TỰ ĐỘNG CHUYỂN TIỀN RA
    // ==========================================
    const exitGame = async () => {
        if (isLoading) return;
        
        // Đóng Iframe ngay lập tức để người chơi không phải đợi
        setPlayGame(null);
        
        if (!product) return;
        setLoading(true);

        try {
            // 1. Kiểm tra số dư hiện tại trong sảnh
            const resBal = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: product });
            const currentBal = resBal.data.data.balance;
            
            // 2. Rút toàn bộ tiền từ sảnh ra ví chính
            if (currentBal >= 1) {
                await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                    product_type: product,
                    type: 2, // 2 là chuyển ra
                    money: Math.floor(currentBal)
                });
                console.log("Rút tiền sảnh thành công!"); // Chỉ in log, không swal
            }
            
            // 3. Cập nhật lại số dư Profile hiển thị
            const resProfile = await axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
            setProfile(resProfile.data.data);
            localStorage.setItem("profile", JSON.stringify(resProfile.data.data));
            
        } catch (err) {
            console.log("Rút tiền sảnh thất bại!", err);
        } finally {
            setLoading(false);
            setProduct(null);
        }
    };

    return (
        <>
            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    background-color: #0b0f17 !important; 
                    margin: 0; padding: 0;
                }

                /* --- GIAO DIỆN GỐC CỦA ĐÁ GÀ --- */
                .cockfight-bg {
                    width: 100%;
                    background-size: cover;
                    background-position: center;
                    background-image: url('https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/cockfight/bg.jpg');
                    min-height: calc(100vh - 60px);
                    padding: 50px 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .wrapper.container {
                    width: 100%;
                    max-width: 1200px;
                }
                .cockfight-lobby .form-row {
                    display: flex;
                    flex-direction: row; 
                    justify-content: center;
                    align-items: center;
                    gap: 60px;
                    flex-wrap: wrap; 
                    width: 100%;
                }
                .cockfight_card {
                    text-align: center;
                    transition: transform 0.3s ease;
                    flex: 0 1 auto;
                }
                .cockfight_card:hover {
                    transform: scale(1.05);
                }
                .box-cock a {
                    text-decoration: none;
                    display: block;
                    position: relative;
                }
                .box-cock img {
                    max-width: 350px; 
                    width: 100%;
                    height: auto;
                    display: block;
                    margin: 0 auto;
                }
                .cock_tittle {
                    color: #ffaa00; 
                    font-size: 24px;
                    font-weight: bold;
                    margin-top: 15px;
                    text-transform: uppercase;
                    text-shadow: 0px 2px 4px rgba(0,0,0,0.8);
                }
                
                @media (max-width: 768px) {
                    .cockfight-lobby .form-row {
                        flex-direction: column;
                        gap: 40px;
                    }
                }

                /* --- IFRAME GAME NHÚNG TRONG TRANG --- */
                .embedded-game-container {
                    width: 100%;
                    height: calc(100vh - 60px); /* Chiều cao trừ đi thanh Header gốc */
                    display: flex;
                    flex-direction: column;
                    background: #111;
                }
                .embedded-game-header {
                    height: 50px;
                    background: #1a1a1a;
                    border-bottom: 2px solid #b71c1c;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start; /* Nút thoát nằm bên trái */
                    padding: 0 15px;
                }
                .btn-exit-game {
                    display: flex;
                    align-items: center;
                    background: #d32f2f;
                    color: #fff;
                    border: none;
                    padding: 8px 15px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: bold;
                    font-size: 14px;
                    text-transform: uppercase;
                    transition: background 0.2s;
                }
                .btn-exit-game:active {
                    background: #b71c1c;
                    transform: scale(0.98);
                }
                .btn-exit-game span { 
                    margin-left: 5px; 
                }
                .game-iframe {
                    width: 100%;
                    flex: 1; /* Chiếm toàn bộ không gian còn lại */
                    border: none;
                    background: #000;
                }
            `}</style>

            <Header profile={profile} />
            
            {isLoading && (
                <div className="loading" style={{ position: "fixed", zIndex: 9999999 }}>
                    <div className="loader"></div>
                </div>
            )}

            {/* ĐIỀU KIỆN HIỂN THỊ: CHƯA VÀO GAME THÌ HIỆN LOBBY, VÀO GAME RỒI THÌ HIỆN IFRAME BÊN DƯỚI HEADER */}
            {!playGame ? (
                <div className="cockfight-bg">
                    <div className="wrapper container">
                        <div className="cockfight-lobby pptop">
                            <div className="form-row">
                                {cockfightProviders.map((provider, index) => (
                                    <div className="cockfight_card" key={index}>
                                        <div className="box-cock">
                                            <a href="#!" onClick={(e) => { e.preventDefault(); launchGame({ product_type: provider.product_type, game_code: provider.game_code }); }} className="p_login">
                                                <img src={provider.img} alt={provider.name} />
                                                <div className="cock_tittle">{provider.name}</div>
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div> 
                </div>
            ) : (
                <div className="embedded-game-container">
                    <div className="embedded-game-header">
                        <button className="btn-exit-game" onClick={exitGame}>
                            <KeyboardArrowLeftOutlinedIcon style={{ fontSize: "20px" }}/>
                            <span>Thoát Game</span>
                        </button>
                    </div>
                    <iframe 
                        src={playGame} 
                        className="game-iframe" 
                        title="Cockfight Game" 
                        allowFullScreen 
                    />
                </div>
            )}
        </>
    );
}

export default Esports;